/**
 * 门户/公共杂项（portalMisc）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/dashboard/（IndexChart/IndexBdc/IndexTask/Workplace）、
 *          src/views/home/sysHome、src/views/exception/ExceptionPage、
 *          src/views/result/（Success/Error）、src/views/profile/（Advanced/basic）、
 *          src/views/waterAnalysisManagement/meterinfoAnalysisCountByMeterType、
 *          src/views/video/（videoRealTime/videoRealTime2）
 * 术语：仪表盘=Dashboard，快捷入口=Quick Entry，待办=To-Do，异常=Exception，
 *       成功=Success，失败=Failed，视频=Video，实时=Real-time
 */
export default {
  // ── dashboard/IndexChart ──
  '水表激活数': 'Activated Meters',
  '当前水表激活总数': 'Total Activated Meters',
  '指标说明': 'Metric Description',
  '欠压数': 'Undervoltage Count',
  '磁干扰数': 'Magnetic Interference Count',
  '阀门故障数': 'Valve Fault Count',
  '故障率': 'Fault Rate',
  '建档数/供水统计': 'Archive Count / Water Supply Statistics',
  '本年度总供水量': 'Annual Water Supply',
  '建档总数': 'Total Archived',
  '昨日建档数': 'Archived Yesterday',
  '今日建档数': 'Archived Today',
  '设备运行分析': 'Device Operation Analysis',
  '综合上报率': 'Overall Report Rate',
  '近七日上报率': '7-Day Reporting Rate',
  '近一年月用水统计': 'Monthly Water Use (Last Year)',
  '近一年月缴费统计': 'Monthly Payment (Last Year)',
  '营收分析': 'Revenue Analysis',
  '交易笔数': 'Transaction Count',
  '各区域近一年用水分析': 'Water Use by Area (Last Year)',
  '上月': 'Last Month',
  '用水量': 'Water Consumption',
  '缴费(元)': 'Payment (CNY)',
  // ── dashboard/IndexBdc ──
  '受理量': 'Accepted Cases',
  '办结量': 'Completed Cases',
  '用户受理量': 'User Accepted Cases',
  '用户办结量': 'User Completed Cases',
  '今日受理量': 'Accepted Today',
  '今日办结量': 'Completed Today',
  '用户今日受理量': 'User Cases Accepted Today',
  '用户今日办结量': 'User Cases Completed Today',
  '本周': 'This Week',
  '本月': 'This Month',
  '本年': 'This Year',
  '所有': 'All',
  '受理监管': 'Acceptance Monitoring',
  '交互监管': 'Interaction Monitoring',
  '存储监管': 'Storage Monitoring',
  '受理量统计': 'Accepted Cases Statistics',
  '快速开始 / 便捷导航': 'Quick Start / Quick Navigation',
  '平台与部门交互量统计': 'Platform-Department Interaction Statistics',
  '转移登记': 'Transfer Registration',
  '抵押登记': 'Mortgage Registration',
  '业务流程限时监管': 'Business Process Time-limit Monitoring',
  '业务节点限时监管': 'Business Node Time-limit Monitoring',
  '业务号': 'Business No.',
  '受理人': 'Acceptor',
  '受理时间': 'Acceptance Time',
  '当前节点': 'Current Node',
  '办理时长': 'Processing Duration',
  '超时时间': 'Overdue Time',
  '超时': 'Overdue',
  '业务受理': 'Business Acceptance',
  '业务管理': 'Business Management',
  '文件管理': 'File Management',
  '信息查询': 'Information Query',
  '根据业务自行处理跳转页面!': 'Please handle the page redirect according to your business!',
  // ── dashboard/IndexTask ──
  '我的在办': 'My In-progress',
  '我的挂账': 'My On-Hold Tasks',
  '我的督办': 'My Supervisions',
  '剩余天数': 'Days Remaining',
  '工单标题': 'Work Order Title',
  '办理': 'Handle',
  '办理完成': 'Completed',
  '请根据具体业务跳转页面': 'Please navigate to the page according to your specific business',
  // ── dashboard/Workplace ──
  '项目数': 'Projects',
  '团队排名': 'Team Ranking',
  '项目访问': 'Project Visits',
  '进行中的项目': 'Projects in Progress',
  '全部项目': 'All Projects',
  '动态': 'Activities',
  '在': 'in',
  '操作一': 'Operation 1',
  '操作二': 'Operation 2',
  '操作三': 'Operation 3',
  '操作四': 'Operation 4',
  '操作五': 'Operation 5',
  '操作六': 'Operation 6',
  'XX 指数': 'XX Index',
  '前端工程师 | 蚂蚁金服 - 某某某事业群 - VUE平台': 'Front-end Engineer | Ant Financial - XX Business Group - VUE Platform',
  // ── home/sysHome ──
  '表务管理': 'Meter Management',
  '管网监测': 'Pipe Network Monitoring',
  '集中抄表': 'Centralized Meter Reading',
  '营业收费': 'Billing & Collection',
  '智慧水务大屏': 'Smart Water Dashboard',
  '通知中心': 'Notification Center',
  '工单管理': 'Work Order Management',
  '巡检管理': 'Inspection Management',
  '工程报装': 'Engineering Installation',
  '客服热线': 'Customer Service Hotline',
  'DMA分区计量': 'DMA District Metering',
  'OA办公': 'OA Office',
  '系统管理': 'System Management',
  '您暂无权限访问，请联系管理员！': 'You do not have permission to access. Please contact the administrator!',
  // ── exception/ExceptionPage ──
  '抱歉，你无权访问该页面': 'Sorry, you do not have permission to access this page',
  '抱歉，你访问的页面不存在或无权访问': 'Sorry, the page does not exist or you do not have access',
  '抱歉，服务器出错了': 'Sorry, the server is having trouble',
  // ── result/Success ──
  '返回列表': 'Back to List',
  '查看项目': 'View Project',
  '项目 ID：': 'Project ID: ',
  '负责人：': 'Person in Charge: ',
  '生效时间：': 'Effective Time: ',
  '创建项目': 'Create Project',
  '部门初审': 'Department Initial Review',
  '财务复核': 'Financial Review',
  '提交结果页用于反馈一系列操作任务的处理结果，\n 如果仅是简单操作，使用 Message 全局提示反馈即可。\n 本文字区域可以展示简单的补充说明，如果有类似展示\n “单据”的需求，下面这个灰色区域可以呈现比较复杂的内容。': 'The submission result page is used to report the outcome of a series of operations.\n For simple operations, a global Message feedback is enough.\n This text area can show simple supplementary descriptions. If you need to display\n “documents”, the gray area below can present more complex content.',
  // ── result/Error ──
  '返回修改': 'Back to Edit',
  '您提交的内容有如下错误：': 'Your submission contains the following errors:',
  '您的账户已被冻结': 'Your account has been frozen',
  '立即解冻': 'Unfreeze Now',
  '您的账户还不具备申请资格': 'Your account is not yet eligible for application',
  '立即升级': 'Upgrade Now',
  '请核对并修改以下信息后，再重新提交。': 'Please verify and modify the following information, then submit again.',
  // ── profile/advanced ──
  '单号：': 'Order No.: ',
  '订购产品': 'Ordered Product',
  '关联单据': 'Related Documents',
  '生效日期': 'Effective Date',
  '订单金额': 'Order Amount',
  '主操作': 'Primary Action',
  '流程进度': 'Process Progress',
  '信息组': 'Information Group',
  '多层信息组': 'Multi-level Information Group',
  '组名称': 'Group Name',
  '用户近半年来电记录': 'Customer Calls in the Last 6 Months',
  '暂无数据': 'No Data',
  '会员卡号': 'Membership Card No.',
  '身份证': 'ID Card',
  '联系方式': 'Contact Number',
  '联系地址': 'Contact Address',
  '某某数据': 'Sample Data',
  '该数据更新时间': 'Data Updated At',
  '角色码': 'Role Code',
  '所属部门': 'Department',
  '过期时间': 'Expiry Time',
  '学名': 'Scientific Name',
  '操作日志一': 'Operation Log 1',
  '操作日志二': 'Operation Log 2',
  '操作日志三': 'Operation Log 3',
  '执行结果': 'Result',
  // ── profile/basic ──
  '退款申请': 'Refund Application',
  '取货单号': 'Pickup Order No.',
  '销售单号': 'Sales Order No.',
  '子订单': 'Sub-order',
  '常用快递': 'Preferred Courier',
  '取货地址': 'Pickup Address',
  '退货商品': 'Returned Goods',
  '退货进度': 'Return Progress',
  '商品编号': 'Product No.',
  '商品名称': 'Product Name',
  '商品条码': 'Product Barcode',
  '数量（件）': 'Quantity (pcs)',
  '当前进度': 'Current Progress',
  '操作员ID': 'Operator ID',
  // ── waterAnalysisManagement ──
  '表类型统计': 'Meter Type Statistics',
  // ── video ──
  '实时视频': 'Real-time Video',
  '错误提示': 'Error',
  'meter_caliber管理页面': 'Meter Caliber Management Page',
  // ── 收尾清理（漏网硬编码补录）──
  '*10秒': '×10 s',
  '分区树': 'District Tree',
  '数据字典': 'Data Dictionary',
  '机械故障': 'Mechanical Failure',
  '流量异常': 'Flow Anomaly',
  '用户管理': 'User Management',
  '用户编号规则配置': 'User No. Rule Configuration',
  '组件0': 'Component 0',
  '组件1': 'Component 1',
  '组件2': 'Component 2',
  '组件4': 'Component 4',
  '菜单管理': 'Menu Management',
  '表单管理': 'Form Management',
  '角色维护': 'Role Maintenance',
  '部门管理': 'Department Management',
  // ── home/sysHome 门户卡片描述 ──
  '水表全生命周期的管理': 'Full lifecycle management of water meters',
  '各种远传设备的数据集采': 'Data collection from various remote-transmission devices',
  '根据用水计量数据，自动计算用户的水费，并提供多种收费方式': 'Automatically calculates water bills from metering data and supports multiple payment methods',
  '展现关键指标，以图形、报表、滚动提醒、动态闪烁等多种方式展示': 'Presents key indicators via charts, reports, scrolling alerts, dynamic flashing and more',
  '基于流程引擎平台搭建工单平台': 'Work order platform built on the process engine',
  '巡检业务流程化管理': 'Process-oriented management of inspection operations',
  '人工坐席管理、单据处理、话务管理、大屏幕管理、客户满意度调查': 'Agent management, ticket handling, call management, big-screen management and customer satisfaction surveys',
  '包含DMA分区管理、分区流量监测、分区压力监测、分区漏损评估等': 'Covers DMA zone management, zone flow/pressure monitoring and leakage assessment',
  '适合水务公司的小型协同管理工作平台,实现部分办公系统智能化及自动化': 'A lightweight collaborative work platform for water utilities, with partial office automation',
  '进行系统设置': 'System configuration',
  // ── meterManagement/modules/MeterPriceItemForm ──
  '该价格编号已存在!': 'This price code already exists!'
}
